export const scrollToId = (id) => {
    const lenis = window.__lenis;
    if (lenis) {
        lenis.scrollTo(`#${id}`, {
            offset: -72,
            duration: 1.4,
            easing: (t) => 1 - Math.pow(1 - t, 4),
        });
    } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
};
